import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Route } from 'react-router-dom';

ReactDOM.render(<App />, document.getElementById('root'));

// Apple app association
const reload = () => window.location.reload();
<Route path="/apple-app-site-association" onEnter={reload} />;

// Strict mode
// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
